import pinia from '/@/stores/index';
<template>
  <div class="fixed-contact" aria-label="联系方式">
    <aside class="brand-contact">
      <div class="brand-button">
        <img src="../assets/img/hxy.png" alt="华欣焱" />
        <span>联系</span>
      </div>
      <div class="brand-popover">
        <strong>华欣焱科技</strong>
        <p><i class="el-icon-message"></i>350372122@qq.com</p>
        <p><i class="el-icon-phone-outline"></i>010-89216288</p>
        <p><i class="el-icon-phone-outline"></i>13811134296</p>
        <p><i class="el-icon-location-outline"></i>北京市大兴区临空经济开发区</p>
      </div>
    </aside>

    <aside class="contact-tools">
      <a
        class="tool-item"
        v-for="item in contactList"
        :key="item.label"
        :href="item.href"
        :target="item.target"
        :aria-label="item.label"
      >
        <i :class="item.icon"></i>
        <span class="tool-tip">{{ item.value }}</span>
      </a>
    </aside>
  </div>
</template>

<script>
export default {
  name: "FixedNotice",
  data() {
    return {
      contactList: [
        {
          label: "电话",
          value: "010-89216288",
          href: "tel:010-89216288",
          icon: "el-icon-phone-outline"
        },
        {
          label: "手机",
          value: "13811134296 余经理",
          href: "tel:13811134296",
          icon: "el-icon-mobile-phone"
        },
        {
          label: "邮箱",
          value: "350372122@qq.com",
          href: "mailto:350372122@qq.com",
          icon: "el-icon-message"
        },
        {
          label: "网站",
          value: "www.huaxinyan.cn",
          href: "http://www.huaxinyan.cn",
          target: "_blank",
          icon: "el-icon-link"
        },
        {
          label: "地址",
          value: "北京市大兴区临空经济开发区",
          href: "#",
          icon: "el-icon-location-outline"
        }
      ]
    };
  }
};
</script>

<style scoped>
.fixed-contact {
  pointer-events: none;
}

.brand-contact,
.contact-tools {
  position: fixed;
  top: 54%;
  z-index: 100;
  pointer-events: auto;
}

.brand-contact {
  left: 18px;
  transform: translateY(-50%);
}

.brand-button {
  width: 48px;
  min-height: 124px;
  padding: 12px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  border-radius: 999px;
  background: #ffffff;
  border: 1px solid rgba(21, 109, 168, 0.12);
  box-shadow: 0 14px 34px rgba(18, 48, 78, 0.13);
}

.brand-button img {
  width: 30px;
  height: 30px;
  object-fit: contain;
}

.brand-button span {
  writing-mode: vertical-rl;
  letter-spacing: 0;
  color: #17324d;
  font-size: 14px;
  font-weight: 700;
}

.brand-popover {
  position: absolute;
  left: 60px;
  top: 50%;
  width: 224px;
  padding: 16px 18px;
  box-sizing: border-box;
  transform: translate(-8px, -50%);
  opacity: 0;
  visibility: hidden;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 18px 44px rgba(18, 48, 78, 0.18);
  transition: opacity 0.22s ease, transform 0.22s ease, visibility 0.22s ease;

    p {
      display: flex;
      align-items: flex-start;
      gap: 8px;
      font-size: 14px;
      line-height: 1.55;
    color: black;    }

    i {
      margin-top: 3px;
      color: #62c7f5;
      font-size: 15px;
    }
}

.brand-popover::before {
  content: "";
  position: absolute;
  left: -6px;
  top: 50%;
  width: 12px;
  height: 12px;
  transform: translateY(-50%) rotate(45deg);
  background: #ffffff;
}

.brand-contact:hover .brand-popover {
  opacity: 1;
  visibility: visible;
  transform: translate(0, -50%);
}

.brand-popover strong {
  display: block;
  color: #142235;
  font-size: 16px;
  line-height: 1.4;
}

.brand-popover p {
  margin: 8px 0 12px;
  color: #6f8195;
  font-size: 13px;
  line-height: 1.6;
}

.brand-popover a {
  color: #d63a30;
  font-size: 16px;
  font-weight: 700;
  text-decoration: none;
}

.contact-tools {
  right: 18px;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.tool-item {
  position: relative;
  width: 46px;
  height: 46px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: #ffffff;
  border: 1px solid rgba(21, 109, 168, 0.12);
  color: #156da8;
  text-decoration: none;
  box-shadow: 0 12px 30px rgba(18, 48, 78, 0.12);
  transition: transform 0.22s ease, background 0.22s ease, color 0.22s ease, box-shadow 0.22s ease;
}

.tool-item:hover {
  transform: translateX(-4px);
  background: #156da8;
  color: #ffffff;
  box-shadow: 0 16px 36px rgba(21, 109, 168, 0.26);
}

.tool-item i {
  font-size: 18px;
}

.tool-tip {
  position: absolute;
  right: 58px;
  top: 50%;
  max-width: 260px;
  padding: 9px 12px;
  transform: translate(8px, -50%);
  opacity: 0;
  visibility: hidden;
  border-radius: 6px;
  background: #142235;
  color: #ffffff;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.45;
  white-space: nowrap;
  box-shadow: 0 12px 28px rgba(20, 34, 53, 0.2);
  transition: opacity 0.2s ease, transform 0.2s ease, visibility 0.2s ease;
}

.tool-tip::after {
  content: "";
  position: absolute;
  right: -5px;
  top: 50%;
  width: 10px;
  height: 10px;
  transform: translateY(-50%) rotate(45deg);
  background: #142235;
}

.tool-item:hover .tool-tip {
  opacity: 1;
  visibility: visible;
  transform: translate(0, -50%);
}

@media (max-width: 1200px) {
  .brand-contact,
  .contact-tools {
    display: none;
  }
}
</style>
